<template>
	<div class="search-tag-list">
	 	<ul>
	        <search-tag v-for="tag in tags" :key='tag.content' v-bind:tag='tag'></search-tag>
	 	</ul>
	</div>
</template>

<script>
    export default {

    	props: ['tags'],

    }
</script>